module.exports = __webpack_public_path__ + "r-v3/img/control_device_setting.13f31f6f.svg";